/**
 * Format rgb array values to rgba(r,b,g,a) string format
 */
/**
 * get rgba(r,b,g,a) individual values
 * @param rgbaStr
 */
const rgbaStr2arr = (rgbaStr)=> {
    let rgbaArr = rgbaStr.split("(")[1].split(")")[0].split(",");
    rgbaArr[0] = parseInt(rgbaArr[0], 10);
    rgbaArr[1] = parseInt(rgbaArr[1], 10);
    rgbaArr[2] = parseInt(rgbaArr[2], 10);
    if (rgbaArr[3]) {
        rgbaArr[3] = parseFloat(rgbaArr[3], 10);
    } else {
        rgbaArr[3] = 1;
    }
    return rgbaArr;
}

/**
 * Format rgb array values to rgba(r,b,g,a) string format
 */
const rgbaArr2Str =(rgbaArr)=> {
    return 'rgba(' + rgbaArr[0] + ',' + rgbaArr[1] + ','
        + rgbaArr[2] + ',' + rgbaArr[3].toFixed(2) + ')';
}

/**
 * turn rgba array values back to rgba(r,g,b,a) format, and update with opacity
 * @param arr
 */
const updateRgbaStrOpacity = (rgbaStr, opacity)=> {
    let arr = rgbaStr2arr(rgbaStr);
    arr.pop();
    return "rgba(" + arr.join(",") + "," + opacity + ")";

}

/**
 * Convert argb hex value to rgoba array. Used in restoring
 * @param hex
 * @returns {any[]}
 */
const argbHex2rgbaArr = (hex)=> {
    let arr = new Array(4);
    arr[2] = hex & 0xFF;
    hex >>= 8;
    arr[1] = hex & 0xFF;
    hex >>= 8;
    arr[0] = hex & 0xFF;
    hex >>= 8;
    arr[3] = (hex & 0xFF) / 255;
    return arr;
}

/**
 * Change rgba individual values (obtained from rgbaStr2arr function) to hex values
 * @param arr
 * @returns {number}
 */
const rgbaArr2argbHex = (arr)=>{
    return (arr[0] << 16) | (arr[1] << 8) | arr[2]
        | (arr[3] * 255 << 24);
}

export {
    updateRgbaStrOpacity,
    rgbaArr2Str,
    rgbaStr2arr,
    argbHex2rgbaArr,
    rgbaArr2argbHex
}